import React, { useState, useEffect } from 'react';
import { Building2 } from 'lucide-react';

interface LoadingScreenProps {
  tenantName?: string;
  onShowDemo?: () => void;
  debugInfo?: any;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  tenantName, 
  onShowDemo,
  debugInfo 
}) => {
  console.log('⏳ LoadingScreen component rendering for:', tenantName);
  const [showDemoButton, setShowDemoButton] = useState(false);
  
  // Show demo button after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDemoButton(true);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center w-full p-4">
      <div className="text-center">
        <div className="flex items-center justify-center mb-6">
         <Building2 className="w-12 h-12 text-tenant-primary mr-3" />
          <h1 className="font-heading text-2xl font-bold text-neutral-800">
            Sanctuary
          </h1>
        </div>
        
       <div className="w-16 h-16 border-4 border-tenant-primary/20 border-t-tenant-primary rounded-full animate-spin mx-auto mb-4"></div>
        
        <h2 className="font-heading text-xl font-semibold text-neutral-800 mb-2">
          {tenantName ? `Loading ${tenantName}` : 'Loading Sanctuary'}
        </h2>
        <p className="font-body text-neutral-600">
          Preparing your cemetery experience...
        </p>
        
        {showDemoButton && onShowDemo && (
          <div className="mt-6">
            <button
              onClick={onShowDemo}
              className="bg-blue-500 text-white px-6 py-3 rounded-lg font-body font-medium hover:bg-blue-600 transition-colors"
            >
              Try Demo Mode
            </button>
            <p className="text-xs text-neutral-500 mt-2">
              Taking too long? Try our demo instead
            </p>
          </div>
        )}
        
        {process.env.NODE_ENV === 'development' && debugInfo && (
          <details className="mt-4 text-left max-w-md mx-auto">
            <summary className="cursor-pointer text-sm text-neutral-500">Debug Info</summary>
            <pre className="mt-2 text-xs bg-neutral-100 p-2 rounded overflow-auto text-neutral-700">
              {JSON.stringify(debugInfo, null, 2)}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
};
export default LoadingScreen;